var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.06,
    height: 15.06
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 194",
    d: "M14.224 10.3a9.238 9.238 0 01-4.091-.935.838.838 0 00-1.121.388L8.412 11a11.782 11.782 0 01-4.346-4.346l1.248-.6a.838.838 0 00.388-1.121A9.206 9.206 0 014.765.842a.837.837 0 00-.837-.837H.839a.837.837 0 00-.837.837 14.24 14.24 0 0014.224 14.224.837.837 0 00.837-.837V11.14a.837.837 0 00-.839-.84z",
    fill: "#5f48e9"
  })));
}

export default SvgPhoneBlue;